import { render, staticRenderFns } from "./support.vue?vue&type=template&id=3b16ec5a&"
import script from "./support.vue?vue&type=script&lang=js&"
export * from "./support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b16ec5a')) {
      api.createRecord('3b16ec5a', component.options)
    } else {
      api.reload('3b16ec5a', component.options)
    }
    module.hot.accept("./support.vue?vue&type=template&id=3b16ec5a&", function () {
      api.rerender('3b16ec5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/peopleVerify/components/support.vue"
export default component.exports